export type TransformOptionContractChangeDataType = {
  Isin: string;
  MarketOpenPositions: number;
  InitialMargin: number;
  RequiredMargin: number;
  MaintenanceMargin: number;
  ContractSize: number;
  StrikePrice: number;
  StartDate: string;
  EndDate: string;
  CashSettlementDate: string;
  PhysicalSettlementDate: string;
  IndividualTraderOpenPositionUpperLimit: number;
  FirmTraderOpenPositionUpperLimit: number;
  BrokerOpenPositionUpperLimit: number;
  MarketOpenPositionUpperLimit: number;
  NumberOfOrdersUpperLimit: number;
  ShareInProportion: boolean;
  SameRiskPositions: number;
  Delta: number;
};

function transformOptionContractChanged(
  data: TransformOptionContractChangeDataType
) {
  const {
    Isin: isin,
    MarketOpenPositions: marketOpenPositions,
    InitialMargin: initialMargin,
    RequiredMargin: requiredMargin,
    MaintenanceMargin: maintenanceMargin,
    ContractSize: contractSize,
    StrikePrice: strikePrice,
    StartDate: startDate,
    EndDate: endDate,
    CashSettlementDate: cashSettlementDate,
    PhysicalSettlementDate: physicalSettlementDate,
    IndividualTraderOpenPositionUpperLimit:
      individualTraderOpenPositionUpperLimit,
    FirmTraderOpenPositionUpperLimit: firmTraderOpenPositionUpperLimit,
    BrokerOpenPositionUpperLimit: brokerOpenPositionUpperLimit,
    MarketOpenPositionUpperLimit: marketOpenPositionUpperLimit,
    NumberOfOrdersUpperLimit: numberOfOrdersUpperLimit,
    ShareInProportion: shareInProportion,
    SameRiskPositions: sameRiskPositions,
    Delta: delta,
  } = data;

  return {
    isin,
    cashSettlementDate,
    contractSize,
    brokerOpenPositionUpperLimit,
    marketOpenPositions,
    initialMargin,
    requiredMargin,
    maintenanceMargin,
    strikePrice,
    startDate,
    endDate,
    physicalSettlementDate,
    individualTraderOpenPositionUpperLimit,
    firmTraderOpenPositionUpperLimit,
    marketOpenPositionUpperLimit,
    numberOfOrdersUpperLimit,
    shareInProportion,
    sameRiskPositions,
    delta,
  };
}

export { transformOptionContractChanged };
